module.exports = __webpack_public_path__ + "img/paragraph-left-align.49356316.svg";